<div class="unauthorized-container">
    <div class="unauthorized-content">
      <p>You are unauthorized to view this page</p>
    </div>
  </div>
  